// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardHeader {
  font-size: 1.25rem;
  display: flex;
  gap: 0.5rem;
  padding: 1.5rem var(--bs-card-cap-padding-x) 0.5rem var(--bs-card-cap-padding-x);
  background-color: #fff;
  border-radius: 1.025rem 1.025rem 0 0;
  border-bottom: none;
}
.CardHeader .card-icon {
  padding: 0 0.5rem;
}
.CardHeader .card-title {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.CardHeader .card-title .card-name {
  text-transform: uppercase;
}
.CardHeader .card-title .card-name .card-help {
  margin-left: 1rem;
  font-size: 1.1rem;
}
.CardHeader .card-title .card-info {
  font-size: 1rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
}
.CardHeader .card-title .card-title-left {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/CardHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gFAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ;AACE;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACE,yBAAA;AACN;AAAM;EACE,iBAAA;EACA,iBAAA;AAER;AACI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AACN;AACI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACN","sourcesContent":[".CardHeader {\n  font-size: 1.25rem;\n  display: flex;\n  gap: 0.5rem;\n  padding: 1.5rem var(--bs-card-cap-padding-x) 0.5rem var(--bs-card-cap-padding-x);\n  background-color: #fff;\n  border-radius: 1.025rem 1.025rem 0 0;\n  border-bottom: none;\n\n  .card-icon {\n    padding: 0 0.5rem;\n  }\n  .card-title {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n    .card-name {\n      text-transform: uppercase;\n      .card-help {\n        margin-left: 1rem;\n        font-size: 1.1rem;\n      }\n    }\n    .card-info {\n      font-size: 1rem;\n      font-weight: 400;\n      color: rgba(0, 0, 0, 0.65);\n    }\n    .card-title-left {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
